export default function() {
    return (
        <span className="text-danger">*</span>
    )
}

